import React from "react";

function Text1() {
  return (
    <div>
      <h1>당신과 잘 어울리는 이름이에요</h1>
    </div>
  );
}

export default Text1;
